import styled from 'styled-components';

export const StyledQuestionInteractionBubble = styled.div`
  .interaction-bubble {
    animation: pulse-bubble 1s infinite;
    animation-delay: ${() => Math.random() * 200}ms;
  }

  @keyframes pulse-bubble {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }
`;
